/** @format */

import { Environment, KillSwitches } from '@shared/data-access/interfaces';
import { Injectable, TransferState, inject, makeStateKey } from '@angular/core';
import { Observable, of } from 'rxjs';

import { injectServerRequestKillSwitches } from '../request-context';

@Injectable({
	providedIn: 'root'
})
export class KillswitchDao {
	private readonly KILLSWITCH_STATE_ENVIRONMENT_KEY_PREFIX = 'kill-switches-environment';
	private readonly killSwitchData = injectServerRequestKillSwitches();
	private readonly state = inject(TransferState);
	private readonly environment = inject(Environment);

	getKillSwitchesFromEnvironment$(): Observable<KillSwitches> {
		// Get unique key
		const STATE_KEY = makeStateKey<KillSwitches | null>(
			`${this.KILLSWITCH_STATE_ENVIRONMENT_KEY_PREFIX}`
		);

		// Attempt to get the state by key
		const stateData: KillSwitches | null = this.state.get<KillSwitches | null>(STATE_KEY, null);
		// Check to see if state exists
		if (stateData !== null) {
			// Return the existing state
			return of(stateData);
		}

		const returnData: KillSwitches =
			this.killSwitchData === null
				? { ...this.environment.killSwitch }
				: { ...this.killSwitchData };

		this.state.set(STATE_KEY, returnData);

		return of(returnData);
	}
}
